import { useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { categoriesQuery } from '../queries';
import { setError } from '../actions';
import { FORM_VALUES } from '../utils/helpers/constants';

export default ({ values, change }) => {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(categoriesQuery);
  const categoriesData = loading ? [] : data?.categories;
  const initialCategoryObj = categoriesData?.find(
    item => item.id === values?.[FORM_VALUES.categoryId]
  );

  useEffect(() => {
    if (!values[FORM_VALUES.typeEstate]) {
      change(FORM_VALUES.typeEstate, initialCategoryObj?.name);
    }
    if (!values[FORM_VALUES.categoryId]) {
      change(FORM_VALUES.categoryId, initialCategoryObj?.id);
    }
  }, [categoriesData.length]);

  useEffect(() => {
    if (error) dispatch(setError(true));
  }, [error]);
};
